import React, { useEffect, useRef } from 'react';
import './Hero.css';

const Hero = () => {
  const heroTextRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (heroTextRef.current) {
      observer.observe(heroTextRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-background">
        <div className="animated-bg">
          <div className="floating-shapes">
            <div className="shape shape-1"></div>
            <div className="shape shape-2"></div>
            <div className="shape shape-3"></div>
            <div className="shape shape-4"></div>
            <div className="shape shape-5"></div>
            <div className="shape shape-6"></div>
          </div>
          <div className="gradient-overlay"></div>
        </div>
      </div>
      
      <div className="hero-content">
        <div className="hero-text" ref={heroTextRef}>
          <h1 className="hero-title">Shiaan</h1>
          <h2 className="hero-subtitle">Full-Stack Developer & Problem Solver</h2>
          <p className="hero-description">
            I write code that actually works (most of the time). 
            Specializing in turning coffee into code and debugging into a full-time hobby. 
            Available for hire when I'm not busy fixing my own bugs.
          </p>
          <div className="hero-buttons">
            <button className="hire-me-btn" onClick={scrollToContact}>
              <span className="btn-line-1">Hire Me</span>
              <span className="btn-line-2">I promise I'm good</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 